var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.data.content)?_c('GridTable',{attrs:{"columns":_vm.columns,"rows":[_vm.data.content]},scopedSlots:_vm._u([{key:"row",fn:function(ref){
var row = ref.row;
return [_c('GridTableCell',[_vm._v(_vm._s(_vm.formatDateTimeForLocale(row.created_at)))]),_c('GridTableCell',[_vm._v(_vm._s(row.description))]),_c('GridTableCell',[_vm._v(_vm._s(row.created_by.name))])]}}],null,false,361199160)}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }